
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import CollapseItem from '@/components/collapse.vue';
	import UploadImg from '@/components/upload-img.vue';
	import draggable from 'vuedraggable'
  import {
    activitySignUpinfo,
    activitySignUpsave
  } from "@/api/live"
  import {
    nextDay
  } from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
      CollapseItem,
      UploadImg,
      draggable
    }
  })

  export default class ProductList extends Vue {
    private loading = false
    private form:any = {
      Id:0,
      State:0,
      ActivityName:'',
      ActivityTime:'',
      ActivityAddress:'',
      SignUpStartTime:'',
      SignUpEndTime:'',
      ActivityMainImgUrl:[],
      ActivityDetailImgUrls:[],
      SignUpObjectType:0,
      CanSignUpMemberRoleGradeList:[],

      zhuce:[],
      MemberRegisterStartTime:'',
      MemberRegisterEndTime:'',

      lingshoushijian:[],
      RetailPerformanceStartTime:'',
      RetailPerformanceEndTime:'',

      RetailPerformance:'',

      tuanduishijian:[],
      TeamPerformanceStartTime:'',
      TeamPerformanceEndTime:'',

      TeamPerformance:'',

      QuotaNumberLimit:'',
      PayMoney:'',
      ActivitySignUpInfoTopicList:[],
    }
    private gradelist = [
      {
				label: 'SVIC',
				value: 1
			},{
				label: 'VIC',
				value: 2
			}, {
				label: 'VIP',
				value: 3
			}, 
    ]
    private typeList = [
      {value:0,label:'单选'},
      {value:1,label:'多选'},
      {value:2,label:'填空'},
    ]
    private i = -1
    private n = -1
    private value = ''
    private hasfill = false

    private mounted () {
      if(Number(this.$route.query.Id)>0){
        this.getinfo()
      }
    }


    private detelePro(i){
      this.form.ActivitySignUpInfoTopicList.splice(i,1)
    }
    private pushPro(){
      this.form.ActivitySignUpInfoTopicList.push({
        Id:0,
        SignUpTopicType:null,
        TopicTitle:'',
        ActivitySignUpInfoTopicOptionList:[],
        IsMustAnswer:true,
        Sort:0,
      })
    }
    private clearopt(i,n){
      this.form.ActivitySignUpInfoTopicList[i].ActivitySignUpInfoTopicOptionList.splice(n,1)
    }
    private getvalue(e,i,n){
      if(!this.value){
        this.$message.error('请输入内容')
        return false
      }
      this.form.ActivitySignUpInfoTopicList[i].ActivitySignUpInfoTopicOptionList[n].OptionDescription = this.value
      this.form.ActivitySignUpInfoTopicList[i].ActivitySignUpInfoTopicOptionList[n].show = false
      this.i = -1
      this.n = -1
      this.hasfill = false
    }
    private changeopt(i,n){
      this.i = i
      this.n = n
      this.value = this.form.ActivitySignUpInfoTopicList[i].ActivitySignUpInfoTopicOptionList[n].OptionDescription
      this.form.ActivitySignUpInfoTopicList[i].ActivitySignUpInfoTopicOptionList[n].show = true
      this.hasfill = true
      this.$nextTick(()=>{
        (this.$refs.value[0] as any).$refs.input.focus();
      })
    }
    private pushOpt(i){
      if(this.hasfill) {
        this.$message.error('请先完善问题选项')
        return
      }

      this.value = ''
      this.form.ActivitySignUpInfoTopicList[i].ActivitySignUpInfoTopicOptionList.push({
        OptionDescription:'',
        Id:0,
        show:true,
        Sort:0,
      })
      this.hasfill = true
      this.$nextTick(()=>{
        (this.$refs.value[0] as any).$refs.input.focus();
      })
    }
    private uploadSuc(list,key){
      this.form[key] = list
    }
    private test(){
      let form = JSON.parse(JSON.stringify(this.form))
      let two = /^\d+(\.\d{1,2})?$/
      if(!form.ActivityName){
        this.$message.error('请输入活动名称')
        return false
      }
      if(!form.ActivityTime){
        this.$message.error('请输入活动时间')
        return false
      }
      if(!form.ActivityAddress){
        this.$message.error('请输入活动地点')
        return false
      }
      if(!form.SignUpStartTime||!form.SignUpEndTime){
        this.$message.error('请完善报名时间')
        return false
      }
      if(new Date(form.SignUpStartTime).getTime() > new Date(form.SignUpEndTime).getTime()){
        this.$message.error('结束时间不能早于开始时间')
        return false
      }
      if(!form.ActivityMainImgUrl||!form.ActivityMainImgUrl.length){
        this.$message.error('请上传活动封面图')
        return false
      }
      if(!form.ActivityDetailImgUrls||!form.ActivityDetailImgUrls.length){
        this.$message.error('请上传活动详情图')
        return false
      }
      if(form.SignUpObjectType==1){
        if(Number(form.RetailPerformance)>0){
          if(!form.lingshoushijian||!form.lingshoushijian.length){
            this.$message.error('请完善业绩要求时间')
            return false
          }
        }
        if(Number(form.TeamPerformance)>0){
          if(!form.tuanduishijian||!form.tuanduishijian.length){
            this.$message.error('请完善业绩要求时间')
            return false
          }
        }
      }
      if(!form.QuotaNumberLimit&&String(form.QuotaNumberLimit)!=='0'){
        this.$message.error('请填写最多报名人数')
        return false
      }
      if(form.QuotaNumberLimit<0||form.QuotaNumberLimit>999999){
        this.$message.error('报名人数请填写0-999999之间')
        return false
      }
      if(!form.PayMoney&&String(form.PayMoney)!=='0'){
        this.$message.error('请填写报名费用')
        return false
      }
      if(form.PayMoney<0||form.PayMoney>999999.99||!two.test(form.PayMoney)){
        this.$message.error('报名费用请填写0-999999.99之间,最多两位小数')
        return false
      }
      for(let item of form.ActivitySignUpInfoTopicList){
        // console.log(item)
        if(item.SignUpTopicType==null){
          this.$message.error('请选择问题类型')
          return false
        }
        if(!item.TopicTitle){
          this.$message.error('请填写问题的标题')
          return false
        }
        if(item.SignUpTopicType!=2){
          if(!item.ActivitySignUpInfoTopicOptionList||!item.ActivitySignUpInfoTopicOptionList.length){
            this.$message.error('请完善选项内容')
            return false
          }
        }
      }


      return true
    }
    private async save(){
      if(!this.test()) return
      try{
        this.loading = true
        let form = JSON.parse(JSON.stringify(this.form))

        if(form.ActivityMainImgUrl&&form.ActivityMainImgUrl.length){
          form.ActivityMainImgUrl = form.ActivityMainImgUrl[0]
        }

        if(form.zhuce&&form.zhuce.length){
          [form.MemberRegisterStartTime,form.MemberRegisterEndTime] = form.zhuce
          form.MemberRegisterEndTime = nextDay(form.MemberRegisterEndTime,1)
        }else{
          [form.MemberRegisterStartTime,form.MemberRegisterEndTime] = ['','']
        }
        if(form.lingshoushijian&&form.lingshoushijian.length){
          [form.RetailPerformanceStartTime,form.RetailPerformanceEndTime] = form.lingshoushijian
          form.RetailPerformanceEndTime = nextDay(form.RetailPerformanceEndTime,1)
        }else{
          [form.RetailPerformanceStartTime,form.RetailPerformanceEndTime] = ['','']
        }
        if(form.tuanduishijian&&form.tuanduishijian.length){
          [form.TeamPerformanceStartTime,form.TeamPerformanceEndTime] = form.tuanduishijian
          form.TeamPerformanceEndTime = nextDay(form.TeamPerformanceEndTime,1)
        }else{
          [form.TeamPerformanceStartTime,form.TeamPerformanceEndTime] = ['','']
        }

        form.ActivitySignUpInfoTopicList = form.ActivitySignUpInfoTopicList.map((v,i)=>{
          v.Sort = i+1
          if(v.SignUpTopicType==2){
            v.ActivitySignUpInfoTopicOptionList = []
          }else{
            v.ActivitySignUpInfoTopicOptionList = v.ActivitySignUpInfoTopicOptionList.map((x,y)=>{
              x.Sort = y+1
              return x
            })
          }
          return v
        })


        let res:any = await activitySignUpsave({Info:form})
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.$router.go(-1)
        }
      }finally{
        this.loading = false
      }
    }
    private async getinfo(){
      try{
        this.loading = true
        let res = await activitySignUpinfo({
          Id:this.$route.query.Id
        })
        if(res.IsSuccess){
          let form = res.Result

          form.ActivityMainImgUrl = form.ActivityMainImgUrl?[form.ActivityMainImgUrl]:[]
          form.zhuce = []
          form.lingshoushijian = []
          form.tuanduishijian = []
          if(form.MemberRegisterStartTime&&form.MemberRegisterEndTime){
            form.zhuce = [form.MemberRegisterStartTime,nextDay(form.MemberRegisterEndTime,-1)]
          }
          if(form.RetailPerformanceStartTime&&form.RetailPerformanceEndTime){
            form.lingshoushijian = [form.RetailPerformanceStartTime,(nextDay(form.RetailPerformanceEndTime,-1))]
          }
          if(form.TeamPerformanceStartTime&&form.TeamPerformanceEndTime){
            form.tuanduishijian = [form.TeamPerformanceStartTime,nextDay(form.TeamPerformanceEndTime,-1)]
          }
          form.ActivitySignUpInfoTopicList = form.ActivitySignUpInfoTopicList.map(v=>{
            v.ActivitySignUpInfoTopicOptionList = v.ActivitySignUpInfoTopicOptionList.map(x=>{
              x.show = false
              return x
            })
            return v
          })
          // console.log(form)
          let time = new Date().getTime()
          let start = new Date(form.SignUpStartTime).getTime()
          let end = new Date(form.SignUpEndTime).getTime()
          if(time < start){
            form.State = 0
          }else if(time > end){
            form.State = 2
          }else{
            form.State = 1
          }


          this.form = form
        }
      }finally{
        this.loading = false
      }
    }
  }
